import { KeyValue } from "@/main/models/common";

export enum UserTypeTypes {
	GET_USER_TYPE = "@userType/GET_USER_TYPE",
	SAVE_USER_TYPE = "@userType/SAVE_USER_TYPE",
	RESET_REDUCER_USER_TYPE = "@userType/RESET_REDUCER_USER_TYPE",

	GET_USER_TYPE_PUBLIC = "@userType/GET_USER_TYPE_PUBLIC",
	SAVE_USER_TYPE_PUBLIC = "@userType/SAVE_USER_TYPE_PUBLIC",
}

export interface UserTypeState {
	readonly userType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};

	readonly userTypePublic: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetUserType {
	type: typeof UserTypeTypes.GET_USER_TYPE;
}

export interface SaveUserType {
	type: typeof UserTypeTypes.SAVE_USER_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface GetUserTypePublic {
	type: typeof UserTypeTypes.GET_USER_TYPE_PUBLIC;
}

export interface SaveUserTypePublic {
	type: typeof UserTypeTypes.SAVE_USER_TYPE_PUBLIC;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerUserType {
	type: typeof UserTypeTypes.RESET_REDUCER_USER_TYPE;
}

export type UserTypeActionTypes =
	| GetUserType
	| SaveUserType
	| ResetReducerUserType
	| GetUserTypePublic
	| SaveUserTypePublic;
